import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import LoadingSpinner from '../components/Common/LoadingSpinner'

export default function Callback() {
  const navigate = useNavigate()
  const { isAuthenticated, isLoading, error } = useAuth0()

  useEffect(() => {
    console.log('Callback - isLoading:', isLoading, 'isAuthenticated:', isAuthenticated, 'error:', error)

    if (error) {
      console.error('Auth0 callback error:', error)
      alert('Authentication error: ' + error.message)
      navigate('/')
      return
    }

    if (!isLoading) {
      if (isAuthenticated) {
        console.log('Auth successful, navigating to dashboard')
        navigate('/dashboard')
      } else {
        console.log('Auth failed, navigating to home')
        navigate('/')
      }
    }
  }, [isLoading, isAuthenticated, error, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <LoadingSpinner />
        <p className="mt-4 text-gray-600">Completing login...</p>
      </div>
    </div>
  )
}
